/**
 * AutoFilters class
 * @private
 */
export class AutoFilters {
}
